import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// ─── ENTRY POINT ──────────────────────────────────────────────────────────────
// Vite entry point for RevCentriQ.
// Mounts the React app into #root in index.html.

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
